import React, { Component } from "react";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button
} from "reactstrap";
import { connect } from 'react-redux';
import BootstrapTable from "react-bootstrap-table-next";
import moment from "moment";
import LottieLoader from '../../LottieLoader';
import lottieEmptyFile from '../../../files/animation/empty_new.json';

class ViewRPMFormLogs extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.toggle}
        size="lg">
        <ModalHeader className="close_button" toggle={this.props.toggle}>
          <Label className="align-items-center justify-content-center text-center"> RPM Submission Logs</Label>
          <Button
            style={{ float: 'right' }}
            onClick={this.props.toggle}            
            className="btn btn-info ml-2 close-click-cls" >
            <i class="mdi mdi-close" style={{
              fontSize: 20
            }}></i>
            Close
          </Button>
        </ModalHeader>

        <ModalBody style={{ backgroundColor: "white" }}>
          <Row>
            <Col md={12}>
            <div className="scrollbar-table-cls">
              <BootstrapTable
                wrapperClasses="table-responsive"
                keyField="_id"
                bordered={true}
                hover={true}
                condensed={true}
                noDataIndication={() => (
                  <div>
                    <LottieLoader
                      loadLoop={false}
                      autoplayLoop={true}
                      source={lottieEmptyFile}
                      Lheight={150}
                      Lwidth={150}
                      titleSmall={"Sorry! No RPM submission log found :("}
                      subTitleSmall={"We can't find any RPM submission logs."}
                    />
                  </div>
                )}
                data={this.props.rpmSubmissinLogs ? this.props.rpmSubmissinLogs : []}
                columns={[
                  {
                    dataField: "description",
                    text: "Created By",
                    formatter: (cell, row) => {
                      if (!row.createdBy) {
                        return <div className="text-left"> - </div>;
                      }
                      return (
                        <div className="text-left">{row.createdBy.fname}{" "} {row.createdBy.lname}</div>
                      );
                    },
                    headerStyle: (colum, colIndex) => {
                      return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                    },
                  },
                  {
                    dataField: "description",
                    text: "Modify By",
                    formatter: (cell, row) => {
                      if (!row.modifyBy) {
                        return <div className="text-left"> Initial Form </div>;
                      }
                      return (
                        <div className="text-left">{row.modifyBy.fname}{" "} {row.modifyBy.lname}</div>
                      );
                    },
                    headerStyle: (colum, colIndex) => {
                      return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                    },
                  },
                  {
                    dataField: "createdDate",
                    text: "Created Date",
                    formatter: (cell, row) => {
                      if (row.createdDate) {
                        return moment(row.createdDate).tz(moment.tz.guess()).format("MMMM DD, YYYY HH:mm:ss");
                      } else {
                        return "NONE";
                      }
                    },
                    headerStyle: (colum, colIndex) => {
                      return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                    },
                  },
                  {
                    dataField: "description",
                    text: "Last Modify Date",
                    formatter: (cell, row) => {
                      if (row.modifyDate) {
                        return moment(row.modifyDate).tz(moment.tz.guess()).format("MMMM DD, YYYY HH:mm:ss");
                      } else {
                        return "NONE";
                      }
                    },
                    headerStyle: (colum, colIndex) => {
                      return { textAlign: "center", padding: "16px", fontSize: "16px", color: "#070707" };
                    },
                  }
                ]}
              />
            </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    )
  }
}

const mapStateToProps = ({ careprovider, user, auth }) => {
  const {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage
  } = careprovider;
  const userDetails = user.userDetails;
  const profileOwner = user.profileOwner;
  return {
    isGenericSuccess,
    isGenericError,
    genericErrorMessage,
    userDetails
  };
};

export default connect(mapStateToProps)(ViewRPMFormLogs);
